import React, { useEffect } from "react";

/**
 * HOC for handling Vite preload errors and basic error handling
 * This should be applied at the top level of the application
 */
const withErrorHandling = <P extends object>(
  WrappedComponent: React.ComponentType<P>
) => {
  return (props: P) => {
    useEffect(() => {
      const handlePreloadError = () => {
        window.location.reload();
      };

      window.addEventListener("vite:preloadError", handlePreloadError);

      return () => {
        window.removeEventListener("vite:preloadError", handlePreloadError);
      };
    }, []);

    return <WrappedComponent {...props} />;
  };
};

export default withErrorHandling;
